<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title" v-t="'message.action_create_long_talkgroup'"></div>
                <hr class="dialog-hr">
                <div class="confirm-title" v-t="'message.info_confirm_create_long_talkgroup'"></div>
                <div class="confirm-text">
                    <div class="confirm-line" v-t="'message.info_confirm_talk_time'"></div>
                    <div class="confirm-line" v-t="'message.info_confirm_multi_talker'"></div>
                    <div class="confirm-line" v-t="'message.info_confirm_user_count'"></div>
                    <div class="confirm-line" v-t="'message.info_confirm_talk_type'"></div>
                    <div class="confirm-line" v-t="'message.info_confirm_restriction'"></div>
                </div>
                <div class="confirm-features" v-html="$t('message.info_confirm_restricted_features')"></div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" @click="$emit('confirmed')">OK</el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {

}
</script>

<style scoped>
.confirm-title {
    padding: 10px 20px 10px 20px;
    font-size: 17px;
}
.confirm-text {
    margin-left: 40px;
    font-size: 16px;
    color: #666;
}
.confirm-features {
    margin-left: 50px;
    margin-bottom: 10px;
    font-size: 15px;
    color: #666;
}
.confirm-line{
    margin-bottom: 4px;
}

</style>
